import type { ReactNode } from 'react';
import { useIsMobile } from '@noor/lib';
import { EatsShellLayout } from './eats-shell-layout';
import { EatsShellLayoutMobile } from './eats-shell-layout.mobile';

interface EatsShellProps {
  children: ReactNode;
}

/**
 * The Eats chrome. Picks between the two shells — they are separate layout
 * trees (see `eats-shell-layout.mobile.tsx`), so exactly one mounts rather than
 * both rendering with one hidden by CSS.
 *
 * The switch lives here, in the widget that owns both chromes, so the root
 * layout stays a plain path→sub-app map and nothing above this needs to know
 * that Eats has two.
 */
export function EatsShell({ children }: EatsShellProps) {
  const isMobile = useIsMobile();

  return isMobile ? (
    <EatsShellLayoutMobile>{children}</EatsShellLayoutMobile>
  ) : (
    <EatsShellLayout>{children}</EatsShellLayout>
  );
}
